import React from "react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { MANIFESTO } from "../data";
import { useContent } from "../ContentContext";

export default function About() {
  const { company } = useContent();
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32" style={{ background: "var(--bone)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-14">
        <div className="md:sticky md:top-28 md:self-start">
          <Eyebrow>About Us</Eyebrow>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]"
              style={{ color: "var(--pine)" }}>
            Rooted in <span className="font-serif-a italic normal-case font-medium" style={{ color: "var(--brass)" }}>experience</span>,
            built on trust
          </h2>
          <p className="mt-6 text-base leading-relaxed max-w-md" style={{ color: "#3a3a3a" }}>
            {company.about_text}
          </p>
          <div className="mt-8 overflow-hidden rounded-2xl">
            <motion.img src={company.about_image} alt="Professional arborist climbing a tree near a home in North Alabama"
              className="w-full h-64 object-cover" initial={{ scale: 1.15 }} whileInView={{ scale: 1 }}
              viewport={{ once: true }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }} />
          </div>
        </div>

        <div className="space-y-2">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.05}>
              <div className="py-8 border-b" style={{ borderColor: "rgba(0,0,0,0.08)" }}>
                <div className="flex gap-6 items-start">
                  <span className="font-serif-a italic text-5xl leading-none" style={{ color: "var(--brass)" }}>{m.n}</span>
                  <div>
                    <h3 className="font-display font-bold uppercase tracking-tight text-xl" style={{ color: "var(--pine)" }}>{m.h}</h3>
                    <p className="mt-2 leading-relaxed" style={{ color: "#4a4a4a" }}>{m.p}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
